<template>
  <div :class="`bottom-banner`" :style="{order:h5ConfigDetails[0]['modalOrder']['BottomBannerOrder'][0]}">
    <div class="banner-list">
      <div class="banner-item" v-for="(item, idx) in bannerList" :key="idx">
        <img @click="jumpToUrl(idx)" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${item}`" alt="">
      </div>
    </div>
    <img class="bg" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['bottomBannerImg']['bottomBannerBg'][0]}`" alt="">
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import appBridge from '@/config/appBridge'

export default {
  name: 'BottomBanner',
  props: ['loginFn'],
  data () {
    return {
      baseUrl,
      bannerList: []
    }
  },
  components: {
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath', 'isLogin'])
  },
  created () {
  },
  mounted () {
    this.bannerList = this.h5ConfigDetails[0]['bottomBannerImg']['bannerImg']
  },
  methods: {
    jumpToUrl(idx){
      if (!this.isLogin) {
        return this.loginFn()
      }
      let jumpLink = this.h5ConfigDetails[0]['bottomBannerText']['bottomBannerLink'][idx]
      if(this.h5ConfigDetails[0]['bottomBannerText']['jumpType'][idx] == 1){ // 站内跳转
        appBridge.appToWeb(jumpLink)
      } else { // 站外跳转
        appBridge.turnToWeb(jumpLink)
      }
    }
  }
}
</script>

<style scoped lang="less">
  .bottom-banner{
    position: relative;
    font-size: 0;
    .bg{
      width: 100%;
      height: auto;
    }

    .banner-list{
      position: absolute;
      top: 0;
      .banner-item{
        &>img{
          width: 100%;
        }
      }
    }
  }

</style>